var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top'),_c('HomeBanner'),_c('news'),_c('Entrance'),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }